module.exports = __webpack_public_path__ + "img/about-page-bg.35b6f080.jpg";